var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-box",staticStyle:{"textAlign":"center"}},[(_vm.url)?_c('img',{staticClass:"img",style:({maxHeight: _vm.maxHeight + 'px', maxWidth: '100%'}),attrs:{"src":`${_vm.url}?token=${_vm.token}`}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }